import PairUnpairSelection from "./PairUnpairSelection.js";
import SelectAssetDevice from "./SelectPairAssetDevice.js";
import SelectChildDevice from "./SelectPairChildDevice.js";
import SelectUnpairDevice from "./SelectUnpairDevice.js";
import PairSummary from "./PairSummary.js";
import Actions from "./actions/PluginSetup.js";
import StaticDetail from "./staticImageDetail/PluginSetup.js";
import AssetPaired from "./AssetPaired.js";
import TagPaired from "./TagPaired.js";
import PairingSuccess from "./PairingSuccess.js";
import UnpairingSuccess from "./UnpairingSuccess.js";
import PairingError from "./PairingError.js";
import UnpairingError from "./UnpairingError.js";
export default {
  install(molten) {
    molten.addPlugin('WizardStep', {
      type: PairUnpairSelection.TYPE,
      content: PairUnpairSelection
    });
    molten.addPlugin('WizardStep', {
      type: SelectAssetDevice.TYPE,
      content: SelectAssetDevice
    });
    molten.addPlugin('WizardStep', {
      type: SelectChildDevice.TYPE,
      content: SelectChildDevice
    });
    molten.addPlugin('WizardStep', {
      type: PairSummary.TYPE,
      content: PairSummary
    });
    molten.addPlugin('WizardStep', {
      type: SelectUnpairDevice.TYPE,
      content: SelectUnpairDevice
    });
    molten.addPlugin('WizardStep', {
      type: AssetPaired.TYPE,
      content: AssetPaired
    });
    molten.addPlugin('WizardStep', {
      type: TagPaired.TYPE,
      content: TagPaired
    });
    molten.addPlugin('WizardStep', {
      type: PairingSuccess.TYPE,
      content: PairingSuccess
    });
    molten.addPlugin('WizardStep', {
      type: UnpairingSuccess.TYPE,
      content: UnpairingSuccess
    });
    molten.addPlugin('WizardStep', {
      type: PairingError.TYPE,
      content: PairingError
    });
    molten.addPlugin('WizardStep', {
      type: UnpairingError.TYPE,
      content: UnpairingError
    });
    Actions.install(molten);
    StaticDetail.install(molten);
  }
};